/**
 * UI Reducer - Used to store users UI preferences
 */

import {
    PIN_SIDEBAR,
    UNPIN_SIDEBAR,
    OPEN_SIDEBAR,
    CLOSE_SIDEBAR,
    SET_TIMESHEET_GROUP_BY,
    SET_PICK_SCHEDULE_LAYOUT
} from './constants';
import { UiState, UiActions } from './types';

const initialState = {
    pinnedSidebar: false,
    openSidebar: false,
    timesheetGroupBy: null,
    pickScheduleLayout: null
};

export default function (
    state: UiState = initialState,
    action: UiActions
): UiState {
    switch (action.type) {
        case PIN_SIDEBAR:
            return {
                ...state,
                pinnedSidebar: true
            };
        case UNPIN_SIDEBAR:
            return {
                ...state,
                pinnedSidebar: false
            };
        case OPEN_SIDEBAR:
            return {
                ...state,
                openSidebar: true
            };
        case CLOSE_SIDEBAR:
            return {
                ...state,
                openSidebar: false
            };
        case SET_TIMESHEET_GROUP_BY:
            return {
                ...state,
                timesheetGroupBy: action.payload.key
            };
        case SET_PICK_SCHEDULE_LAYOUT:
            return {
                ...state,
                pickScheduleLayout: action.payload.layoutName
            };
        default:
            return state;
    }
}
